module.exports = __webpack_public_path__ + "img/bg1_left.925f2316.jpg";